window.nss_blog_recipe_init = function() {
    document.querySelectorAll('[js-toggle-blog-filter-wrap]').forEach((blogMobileFilterToggle) => {
        blogMobileFilterToggle.addEventListener('click', (e) => {
            const filterWrap = e.target.closest('[js-blog-filter-wrap]');
            filterWrap.classList.toggle('options--show');
        });
    });
    document.querySelectorAll('[js-toggle-blog-filter-group]').forEach((blogMobileFilterToggle) => {
        blogMobileFilterToggle.addEventListener('click', (e) => {
            const filterWrap = e.target.closest('[js-blog-filter-group]');
            filterWrap.classList.toggle('options--show');
        });
    });
}

if (!window.nss_blog_recipe_initialized) {
    window.nss_blog_recipe_initialized = true;
    document.addEventListener('DOMContentLoaded', function(){
        window.nss_blog_recipe_init();
    });
}
